import { Modal } from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark } from '@fortawesome/pro-regular-svg-icons'

// Mirrors @wetu/design-system-components Dialog (gray header, floating close, padded body),
// built on reactstrap's Modal so it stacks above iframes and Userpilot content.
const Dialog = ({ isOpen, onClose, header, body, size = 'default', labelledBy }) => {
    return (
        <Modal
            centered
            isOpen={isOpen}
            toggle={onClose}
            modalClassName="ds-dialog-modal"
            className={`ds-dialog ds-dialog--${size}`}
            contentClassName="ds-dialog__content"
            labelledBy={labelledBy}
        >
            <div className="ds-dialog__header">
                <div className="ds-dialog__header-text">{header}</div>
                <button type="button" className="ds-dialog__close" aria-label="Close dialog" onClick={onClose}>
                    <FontAwesomeIcon icon={faXmark} aria-hidden="true" />
                </button>
            </div>
            <div className="ds-dialog__body">{body}</div>
        </Modal>
    )
}

export default Dialog
